import type { MineNudge, MineNudgeKind } from '@/versions/v1/schema/mine-nudge';

export type MineNudgeRowModel = {
  id: string;
  kindLabel: string;
  headline: string;
  basis: string;
  dispatchChip: string;
  provenanceChip: string;
  provenanceTooltip: string;
  instructionTooltip?: string;
};

const KIND_ORDER: Record<'gm' | 'superintendent', readonly MineNudgeKind[]> = {
  gm: ['blend', 'location-rate'],
  superintendent: ['location-rate', 'blend'],
};

function kindLabel(kind: MineNudgeKind): string {
  return kind === 'blend' ? 'blend' : 't/h to location';
}

/** Role-ordered view models for mine-side nudge rows. */
export function mineNudgeRowsForRole(
  nudges: readonly MineNudge[],
  role: 'gm' | 'superintendent',
): readonly MineNudgeRowModel[] {
  const order = KIND_ORDER[role];
  return order
    .map((kind) => nudges.find((row) => row.kind === kind))
    .filter((row): row is MineNudge => Boolean(row))
    .map((row) => ({
      id: row.id,
      kindLabel: kindLabel(row.kind),
      headline: row.headline,
      basis: row.basis,
      dispatchChip: row.target,
      provenanceChip: '[syn]',
      provenanceTooltip: row.provenance,
      instructionTooltip: row.instructionTooltip,
    }));
}
